export const HEROES_SPRITE = '/public/assets/heroes/heroes.png';

export const HERO_IMAGE_SIZE = 50;

export const HERO_CLASSES_MAP = {
  // TBD
  FLAME_SWORDSMAN: {
    icon: { sx: 0, sy: 0 },
    portrait: { sx: 0, sy: 240 },
    className: 'Flame swordsman',
  },
};
